import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import axios from "axios";
import {toast} from "react-toastify";
import {
    setPrescriptionsReportRequestData,
    setPrescriptionsReportResponseData
} from "../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import moment from "moment";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import Button from "react-bootstrap/Button";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import {formatPrescriptionStatus, getPrescriptionColor} from "./constants";
import * as XLSX from "xlsx";
import {jsPDF} from "jspdf";
import {autoTable} from "jspdf-autotable";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import Input from "../../../common/Input";
import {useTranslation} from "../../../../hooks/useTranslation";

const ReportsPrescriptions = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.PRESCRIPTION.prescriptionsReportRequestData);
    const responseData = useSelector((state) => state.PRESCRIPTION.prescriptionsReportResponseData);

    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);

    const dateTypes = [
        {value: "startDate", label: "Ημερομηνία συνταγογράφησης"},
        {value: "executionDate", label: "Ημερομηνία εκτέλεσης"},
        {value: "endDate", label: "Ημερομηνία λήξης"}
    ]

    const statusOptions = [
        {value: "", label: "Προβολή όλων"},
        {value: "new", label: "Συνταγογραφημένες"},
        {value: "completed", label: "Εκτελεσμένες"},
        {value: "active", label: "Μερικώς Εκτελεσμένες"},
        {value: "cancelled", label: "Ακυρωμένες"},
        {value: "held", label: "Υπο Θεώρηση/Προσωρινά Συνταγογραφημένες"},
        {value: "aborted", label: "Απορριφθείσες"}
    ]

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const fetchReport = (fromPagination = false, showToast = true) => {
        if (isEmpty(requestData.date_from) || isEmpty(requestData.date_to)) return toast.error("Παρακαλώ συμπληρώστε ημερομηνία από και έως.");

        let toReq = {
            ...requestData,
            company: company.id,
            page: fromPagination ? requestData.page : 1,
        }

        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/reports-prescriptions`, toReq, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setPrescriptionsReportResponseData({
                    ...responseData,
                    data: res.data.data,
                    totalItems: res.data.totalItems,
                    totalPages: res.data.totalPages,
                }));
                if (!fromPagination) {
                    dispatch(setPrescriptionsReportRequestData({...requestData, page: 1}));
                    if (showToast) toast.success("Τα δεδομένα ανανεώθηκαν", {autoClose: 1000});
                }
            } else {
                if (showToast) toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        let prepChange = {};
        if (type === "db") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        }
        dispatch(setPrescriptionsReportRequestData({...requestData, ...prepChange}));
    }

    const handleExcelExport = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/prescription/reports-prescriptions`, {
                ...requestData,
                page: -1,
                company: company.id,
            }, {
                headers: { 'Content-Type': 'application/json' },
            })
            if (response.data.status === "200") {
                const responseData = response.data.data;
                let rows = [];
                const dateExported = moment().format("DD/MM/YYYY HH:mm:ss");
                if (!isEmpty(requestData.date_from) && !isEmpty(requestData.date_to)) rows.push([`Εύρος ημερομηνίας: ${requestData.date_from} - ${requestData.date_to}`]);
                rows.push(["Επωνυμία:", company.name]);
                rows.push(["ΑΦΜ:", company.vatNumber]);
                rows.push([`Ημερομηνία Εξαγωγής: ${dateExported}`]);
                rows.push([]);
                rows.push([
                    "Barcode συνταγής",
                    "Κατάσταση συνταγής",
                    "Ημ/νια έναρξης",
                    "Ημ/νια εκτέλεσης",
                    "Ημ/νια λήξης",
                    "AMKA Ασθενή / ΑΜΑ Ασθενή",
                    "Ον/μο Ασθενή",
                    "Συνταγογραφημένο Φάρμακο",
                    "Εκτελεσμένο Φάρμακο",
                    "Ποσότητα",
                ]);
                responseData.forEach((row) => {
                    row.drugs.forEach((drug, idx2) => {
                        rows.push([
                            idx2 === 0 ? row.prescriptionId : "",
                            formatPrescriptionStatus(row.status),
                            !isEmpty(row.startDate) ? moment(row.startDate).format("DD/MM/YYYY") : "",
                            !isEmpty(row.executionDate) ? moment(row.executionDate).format("DD/MM/YYYY") : "",
                            !isEmpty(row.endDate) ? moment(row.endDate).format("DD/MM/YYYY") : "",
                            row.clientAMKA + " / " + row.clientAMA,
                            row.clientName,
                            drug.erp_displayName,
                            matchingExecuted(row, idx2),
                            drug.erp_drugAmount
                        ])
                    })
                })
                const workSheet = XLSX.utils.aoa_to_sheet(rows);
                const workBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workBook, workSheet, "Συνταγές");
                XLSX.writeFile(workBook, 'Αναφορά Συνταγών.xlsx');
            } else {
                return toast.error(response.data.message);
            }
        } catch (e) {
            console.log(e);
            toast.error("Σφάλμα κατά την άντληση δεδομένων.");
        }
    }

    const handlePDFExport = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/prescription/reports-prescriptions`, {
                ...requestData,
                page: -1,
                company: company.id,
            }, {
                headers: { 'Content-Type': 'application/json' },
            })
            if (response.data.status === "200") {
                const responseData = response.data.data;
                let rows = [];
                const headerColumns = [
                    "Barcode συνταγής",
                    "Κατάσταση συνταγής",
                    "Ημ/νια έναρξης",
                    "Ημ/νια εκτέλεσης",
                    "Ημ/νια λήξης",
                    "AMKA Ασθενή / ΑΜΑ Ασθενή",
                    "Ον/μο Ασθενή",
                    "Συνταγογραφημένο Φάρμακο",
                    "Εκτελεσμένο Φάρμακο",
                    "Ποσότητα",
                ]
                for (let row of responseData) {
                    row.drugs.forEach((drug, idx2) => {
                        rows.push([
                            idx2 === 0 ? row.prescriptionId : "",
                            formatPrescriptionStatus(row.status),
                            !isEmpty(row.startDate) ? moment(row.startDate).format("DD/MM/YYYY") : "",
                            !isEmpty(row.executionDate) ? moment(row.executionDate).format("DD/MM/YYYY") : "",
                            !isEmpty(row.endDate) ? moment(row.endDate).format("DD/MM/YYYY") : "",
                            row.clientAMKA + " / " + row.clientAMA,
                            row.clientName,
                            drug.erp_displayName,
                            matchingExecuted(row, idx2),
                            drug.erp_drugAmount
                        ])
                    })
                }
                const doc = new jsPDF('landscape');
                let y = 20;
                doc.addFileToVFS("arialuni.ttf", liberationSerif);
                doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                doc.setFont("DejaVu Sans Bold");
                doc.setFontSize(10);
                const header = doc.splitTextToSize(`Αναφορά Συνταγών`, 200);
                const headerString = header.join("\n");
                doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
                doc.setFont("DejaVu Sans Normal");
                const imgData = 'assets/images/prrimer-logo.png';
                const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
                const imgY = 3; // adjust the position as needed
                doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
                doc.setFont("DejaVu Sans Normal");
                autoTable(doc, {
                    startY: y,
                    head: [headerColumns],
                    body: rows,
                    rowPageBreak: "avoid",
                    styles: {
                        font: "DejaVu Sans Normal",
                        fontStyle: "normal",
                        fontSize: 8, // set font size
                        halign: "center", // set alignment
                    },
                })
                const pageCount = doc.getNumberOfPages();
                // Add the pagination to each page
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                }
                doc.save(`Αναφορά Συνταγών.pdf`);
            } else {
                return toast.error(response.data.message);
            }
        } catch (e) {
            console.log(e);
            toast.error("Σφάλμα κατά την άντληση δεδομένων.");
        }
    }

    const toFirstPage = () => {
        dispatch(setPrescriptionsReportRequestData({...requestData, page: 1}));
        setPageChanged(true);
    }

    const toPreviousPage = () => {
        dispatch(setPrescriptionsReportRequestData({...requestData, page: requestData.page - 1}));
        setPageChanged(true);
    }

    const toNextPage = () => {
        dispatch(setPrescriptionsReportRequestData({...requestData, page: requestData.page + 1}));
        setPageChanged(true);
    }

    const toLastPage = () => {
        dispatch(setPrescriptionsReportRequestData({...requestData, page: responseData.totalPages}));
        setPageChanged(true);
    }

    const matchingExecuted = (row, idx2) => {
        if (row.status === "active" || row.status === "completed") {
            if (row.drugsExecuted) {
                if (row.drugsExecuted[idx2]) {
                    return row.drugsExecuted[idx2]?.erp_displayName;
                }
            } else {
                return row.drugs[idx2]?.erp_displayName;
            }
        }
        return "";
    }

    return (
        <div onKeyDown={(e) => {
            if (e?.key === "Enter") fetchReport(false, false);
        }}>
            <Row>
                <Col md={3}>
                    <Dropdown
                        name={"dateType"}
                        label={"Τύπος ημερομηνίας"}
                        options={dateTypes}
                        defaultValue={dateTypes.find((el) => el.value === requestData.dateType)}
                        key={Math.random()}
                        onChange={(e) => handleOnChange(e, "dd", "dateType")}
                    />
                </Col>
                <Col md={2}>
                    <DateHelper
                        dateFromAndToFunction={(from, to) => dispatch(setPrescriptionsReportRequestData({...requestData, date_from: from, date_to: to}))}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="date_from"
                        selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                        label={"Ημερομηνία από"}
                        allowOtherYears={true}
                        onChange={(e) => handleOnChange(e, "db", "date_from")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="date_to"
                        selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                        label={"Ημερομηνία έως"}
                        allowOtherYears={true}
                        onChange={(e) => handleOnChange(e, "db", "date_to")}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        name={"status"}
                        label={"Κατάσταση συνταγής"}
                        options={statusOptions}
                        defaultValue={statusOptions.find((el) => el.value === requestData.status)}
                        onChange={(e) => handleOnChange(e, "dd", "status")}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Input
                        name={"barcode"}
                        label={"Barcode"}
                        value={requestData.barcode}
                        onChange={(e) => handleOnChange(e, "input", "barcode")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"identifier"}
                        label={"ΑΜΚΑ/AMA/Όνομα ασθενή"}
                        value={requestData.identifier}
                        onChange={(e) => handleOnChange(e, "input", "identifier")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"medicine"}
                        label={"Περιεχόμενο φάρμακο"}
                        value={requestData.medicine}
                        onChange={(e) => handleOnChange(e, "input", "medicine")}
                    />
                </Col>
                <Col md={3}>
                    <Button style={{marginTop: "20px"}} disabled={loading} onClick={() => fetchReport(false)}>
                        Εφαρμογή φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Col>
            </Row>
            {responseData.data?.length > 0 && (
                <React.Fragment>
                    {responseData.totalPages > 0 && (
                        <React.Fragment>
                            <Row className={"mt-2"}>
                                <Col md={3}>
                                    <div className={"text-muted"} style={{marginTop: "10px"}}>Σύνολο αποτελεσμάτων: {responseData.totalItems}</div>
                                </Col>
                                <Col md={9}>
                                    <div className="d-flex justify-content-end mb-2">
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toFirstPage()}
                                            disabled={requestData.page === 1 || loading}
                                        >
                                            {t('SalesBalanceSheet.first')}
                                        </Button>
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toPreviousPage()}
                                            disabled={requestData.page === 1 || loading}
                                        >
                                            {t('SalesBalanceSheet.previous')}
                                        </Button>
                                        <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1"
                                               bg="primary">{t('SalesBalanceSheet.page')} {requestData.page} / {responseData.totalPages}</Badge>
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toNextPage()}
                                            disabled={requestData.page === responseData.totalPages || loading}
                                        >
                                            {t('SalesBalanceSheet.next')}
                                        </Button>
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toLastPage()}
                                            disabled={requestData.page === responseData.totalPages || loading}
                                        >
                                            {t('SalesBalanceSheet.last')}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                    <span>Προβάλονται 10 συνταγές ανά σελίδα</span>
                    <table className={"simpleClassicTable mt-2"} style={{fontSize: "12px", fontWeight: "600"}}>
                        <colgroup>
                            <col span={1} style={{width: "10%"}}></col>
                            <col span={1} style={{width: "10%"}}></col>
                            <col span={1} style={{width: "8%"}}></col>
                            <col span={1} style={{width: "8%"}}></col>
                            <col span={1} style={{width: "8%"}}></col>
                            <col span={1} style={{width: "10%"}}></col>
                            <col span={1} style={{width: "11%"}}></col>
                            <col span={1} style={{width: "15%"}}></col>
                            <col span={1} style={{width: "15%"}}></col>
                            <col span={1} style={{width: "5%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Barcode συνταγής</th>
                            <th>Κατάσταση συνταγής</th>
                            <th>Ημ/νια έναρξης</th>
                            <th>Ημ/νια εκτέλεσης</th>
                            <th>Ημ/νια λήξης</th>
                            <th>AMKA Ασθενή / ΑΜΑ Ασθενή</th>
                            <th>Ον/μο Ασθενή</th>
                            <th>Συνταγογραφημένο Φάρμακο</th>
                            <th>Εκτελεσμένο Φάρμακο</th>
                            <th>Ποσότητα</th>
                        </tr>
                        </thead>
                        <tbody>
                        {responseData.data.map((row, idx) => {
                            let tdArr = [];
                            if (row.type === "normal" || isEmpty(row.type)) {
                                row.drugs.forEach((drug, idx2) => {
                                    tdArr.push(
                                        <tr key={`prescRep-${idx}-${idx2}`} style={{backgroundColor: getPrescriptionColor(row.status)}}>
                                            <td>{idx2 === 0 ? row.prescriptionId : ">>"}</td>
                                            <td>{formatPrescriptionStatus(row.status)}</td>
                                            <td>{!isEmpty(row.startDate) ? moment(row.startDate).format("DD/MM/YYYY") : ""}</td>
                                            <td>{!isEmpty(row.executionDate) ? moment(row.executionDate).format("DD/MM/YYYY") : ""}</td>
                                            <td>{!isEmpty(row.endDate) ? moment(row.endDate).format("DD/MM/YYYY") : ""}</td>
                                            <td>{row.clientAMKA} <br/> {row.clientAMA}</td>
                                            <td>{row.clientName}</td>
                                            <td>{drug.erp_displayName}</td>
                                            <td>{matchingExecuted(row, idx2)}</td>
                                            <td>{drug.erp_drugAmount}</td>
                                        </tr>
                                    )
                                })
                            } else if (row.type === "ifet") {
                                row.ifet.forEach((drug, idx2) => {
                                    tdArr.push(
                                        <tr key={`prescRep-${idx}-${idx2}`} style={{backgroundColor: getPrescriptionColor(row.status)}}>
                                            <td>{idx2 === 0 ? row.prescriptionId : ">>"}</td>
                                            <td>{formatPrescriptionStatus(row.status)}</td>
                                            <td>{!isEmpty(row.startDate) ? moment(row.startDate).format("DD/MM/YYYY") : ""}</td>
                                            <td>{!isEmpty(row.executionDate) ? moment(row.executionDate).format("DD/MM/YYYY") : ""}</td>
                                            <td>{!isEmpty(row.endDate) ? moment(row.endDate).format("DD/MM/YYYY") : ""}</td>
                                            <td>{row.clientAMKA} <br/> {row.clientAMA}</td>
                                            <td>{row.clientName}</td>
                                            <td>{`ΕΙΣΑΓΩΓΗ ΜΕΣΩ ΙΦΕΤ ${drug.erp_active_substance} ${drug.erp_form} ${drug.erp_content}`}</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                    )
                                })
                            }
                            return tdArr;
                        })}
                        </tbody>
                    </table>
                    <Row>
                        <BootstrapDropdown className="mb-3 mt-3">
                            <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic">
                                Αποθήκευση αποτελεσμάτων
                            </BootstrapDropdown.Toggle>
                            <BootstrapDropdown.Menu>
                                <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                    Αποθήκευση ως PDF
                                </BootstrapDropdown.Item>
                                <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                    Αποθήκευση ως XLSX
                                </BootstrapDropdown.Item>
                            </BootstrapDropdown.Menu>
                        </BootstrapDropdown>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export default ReportsPrescriptions
